var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"6.5","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M8 5V9L10 11","stroke":"currentColor","key":1})]);
}

Clock.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
